import type { components } from '~/types/napis'

export type Grading_Type = components['schemas']['CVGradingTypeOptions']

export type Cv_Feedback_Grading_Category =
  | 'Relevancy to the job family'
  | 'Right depth in work experiences'
  | `Followed "What, How and Results" format`
  | 'Education & Qualification Coverage'
  | 'Concise and Precise Language'
  | 'Not including excess personal information'

export type Cv_Feedback =
  | components['schemas']['CVReviewForGradingResult']['result_json']
  | {
      job_family: string
      overall_feedback: string
      grading: {
        category: Cv_Feedback_Grading_Category
        score: number
        feedback: string
      }[]
    }

export type Cv_Parsed_Data = {
  UserProfile: {
    first_name: string | null
    last_name: string | null
    email: string | null
    phone: string | null
    bio: string | null
    // linkedin_link?: string | null
    // github_link?: string | null
    // facebook_link?: string | null
    // x_link?: string | null
    // instagram_link?: string | null
    // tiktok_link?: string | null
    // behance_link?: string | null
    // dribbble_link?: string | null
    // website_link?: string | null
    language: string[] | null
    skill: string[] | null
  } | null
  UserProfileEducationItem:
    | {
        school: string | null
        degree: string | null
        major?: string | null
        gpa?: string | null
        start_date: string | null
        end_date: string | null
        currently_studying: boolean | null
        description: string[] | null
      }[]
    | null
  UserProfileWorkExperienceItem:
    | {
        company: string | null
        title: string | null
        country: string
        city: string | null
        start_date: string | null
        end_date: string | null
        currently_working: boolean | null
        experience_level: string | null
        job_mode: string | null
        description: string[] | null
      }[]
    | null
}

// updated to components['schemas']['ResumeParsingResultSchema']
export type Cv_Parsed_Data_Result = components['schemas']['ResumeParsingResultSchema']

export const cv_grade_weightage = {
  'Relevancy to the job family': 45,
  'Right depth in work experiences': 15,
  'Followed "What, How and Results" format': 15,
  'Education & Qualification Coverage': 10,
  'Concise and Precise Language': 10,
  'Not including excess personal information': 5
}

export const cv_grade_total_weightage = 100

export type CvEditorAboutForm = {
  first_name: string
  last_name: string
  email: string
  bio: string
  profile_languages: string[]
  skills: string[]
}

type BaseCvEditorWorkForm = components['schemas']['CreateUserProfileWorkExperienceSchema']

export type CvEditorWorkForm = BaseCvEditorWorkForm & { id_slug: string }

type BaseCvEditorEduForm = components['schemas']['CreateUserProfileEducationSchema']

export type CvEditorEduForm = BaseCvEditorEduForm & {
  id_slug: string
  grade: string
  max_grade: string
}

export type CvEditorFormPayload = {
  about: {
    first_name: string
    last_name: string
    bio: string
    profile_languages: string[]
    skills: string[]
  }
  edus: CvEditorEduForm[]
  works: CvEditorWorkForm[]
  deletedWork: string[]
  deletedEdu: string[]
}

export type CVEducationGradeType = 'LETTER' | 'PERCENTAGE' | 'GPA' | 'CLASS' | 'PASS' | 'OTHER'

export type CVEducationMaxGradeOptions = { [K in CVEducationGradeType]: string[] }

export type CVEducationGradeTypeCard = {
  id: CVEducationGradeType
  title: string
}
